// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /pickem/missing-picks-list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePickemMissingPicksListBody,
  typePickemMissingPicksListOutput200,
} from "../../sdk/pickem/postPickemMissingPicksList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPickemMissingPicksListQueryKey(
  payload: typePickemMissingPicksListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`roundId:${JSON.stringify(payload.roundId)}`);
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return [
    "post:pickem:pickemMissingPicksList",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePickemMissingPicksListOutput200,
    unknown,
    typePickemMissingPicksListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePickemMissingPicksList(
  payload: typePickemMissingPicksListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPickemMissingPicksListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPickemMissingPicksList(payload),
    ...resolvedOptions,
  });
}
